import { inject } from '@angular/core';
import { CanActivateFn, RedirectCommand, Router } from '@angular/router';
import { FolderSyncService } from '../services/folder-sync.service';
import { logGuardResult } from './guard-logger';

/**
 * Redirects deep links to the folder-share source screen back to the source
 * selection when the browser does not support the File System Access API.
 */
export const folderShareSupportedGuard: CanActivateFn = () => {
  const folderSyncService = inject(FolderSyncService);
  const router = inject(Router);

  if (folderSyncService.isSupported()) {
    return logGuardResult('folderShareSupportedGuard', true, {
      reason: 'File System Access API supported',
    });
  }

  return logGuardResult(
    'folderShareSupportedGuard',
    new RedirectCommand(router.parseUrl('/upload')),
    { reason: 'File System Access API not supported' }
  );
};
